export const getTranslations = t => {
  return {
    yourCart: t("kf.cart.label.yourCart"),
    emptyCart: t("kf.cart.label.emptyCart"),
    sharCartLink: t("kf.cart.label.sharCartLink"),
    sharCartLinkCopied: t("kf.cart.label.sharCartLinkCopied"),
    qty: t("kf.cart.label.quantity"),
    unitPrice: t("kf.cart.label.unitPrice"),
    total: t("kf.cart.label.total"),
    colorFinish: t("kf.cart.label.colorFinish"),
    shape: t("kf.cart.label.shape"),
    coverage: t("kf.cart.label.coverage"),
    sku: t("kf.cart.label.sku"),
    inStockMsg: t("kf.cart.label.inStockMsg"),
    saveLater: t("kf.cart.label.saveLater"),
    remove: t("kf.cart.label.remove"),
    continueCheckout: t("kf.cart.label.continueCheckout"),
    orderSummary: t("kf.cart.label.orderSummary"),
    LoadCart: t("Kf.button.action.loadcart"),
    collabrativeCartDecs: t("kf.cart.label.collbcartdecs"),
    createcart: t("kf.cart.lable.createcart"),
    customersCartID: t("kf.cart.lable.customercartid"),
    subTotal: t("kf.cart.label.subTotal"),
    totalPromotions: t("kf.cart.label.totalPromotions"),
    estimatedShipping: t("kf.cart.label.estimatedShipping"),
    estimatedTax: t("kf.cart.label.estimatedTax"),
    estimatedTotal: t("kf.cart.label.estimatedTotal"),
    enterPromo: t("kf.cart.label.enterPromo"),
    coupon: t("kf.cart.label.coupon"),
    apply: t("kf.global.label.apply"),
    free: t("kf.cart.label.free"),
    freeShipping: t("kf.label.freeShipping"),
    previousDiscountErr: t("kf.cart.error.previousDiscountErr"),
    combinePromoErr: t("kf.cart.error.combinePromoErr"),
    maxAppReachedErr: t("kf.cart.error.maxAppReachedErr"),
    promoNotApplicable: t("kf.cart.error.promoNotApplicable"),
    invalidPromoErr: t("kf.cart.error.invalidPromoErr"),
    noPromoErr: t("kf.cart.error.noPromoErr"),
    alreadyAppliedErr: t("kf.cart.error.alreadyAppliedErr"),
    update: t("kf.global.label.update"),
    zipCode: t("kf.cart.label.zipCode"),
    edit: t("kf.cart.label.edit"),
    cart: t("kf.cart.label.cart"),
    shareCart: t("kf.cart.label.shareCart"),
    shareCartDesc: t("kf.cart.label.shareCartDesc"),
    downloadSpecs: t("kf.cart.label.downloadSpecs"),
    noItemsInCart: t("kf.cart.label.noItemsInCart"),
    addA: t("kf.cart.label.addA"),
    or: t("kf.global.label.or"),
    recentlyViewedItem: t("kf.cart.label.recentlyViewedItem"),
    recentlyViewedTitle: t("kf.cart.label.recentlyViewedTitle"),
    recentlyViewedColor: t("kf.pairsWellWith.label.color"),
    recentlyViewedColors: t("kf.pairsWellWith.label.colors"),
    ariaLabelColor: t("kf.pairsWellWith.aria.colors"),
    ariaLabelTooltip: t("kf.pairsWellWith.aria.tooltip"),
    continueShopping: t("kf.cart.label.continueShopping"),
    alert: t("kf.global.label.alert"),
    outOfStock: t("kf.cart.label.outOfStock"),
    outOfStockAlert: t("kf.cart.label.outOfStockAlert"),
    cannotShip: t("kf.cart.label.cannotShip"),
    callSupport: t("kf.cart.label.callSupport"),
    needMoreTime: t("kf.cart.label.needMoreTime"),
    saveCartMssg: t("kf.cart.label.saveCartMssg"),
    createAccount: t("kf.cart.label.createAnAccount"),
    createProfessionalAccount: t("kf.cart.label.createProfessionalAccount"),
    createCartAccount: t("kf.cart.label.createCartAccount"),
    saveYourCart: t("kf.cart.label.saveYourCart"),
    taxTooltip: t("kf.cart.label.taxTooltip"),
    shippingTooltip: t("kf.cart.label.shippingTooltip"),
    oversizedDelivery: t("kf.cart.label.oversizedDelivery"),
    oversizedFragileDelivery: t("kf.cart.label.oversizedFragileDelivery"),
    freightShipping: t("kf.orderDetails.label.freightShipping"),
    freightLabel: t("kf.orderSUmmary.label.freightLabel"),
    validZipcode: t("kf.checkout.error.validZipcode"),
    zipCodeError: t("kf.checkout.error.zipcodeError"),
    note: t("kf.cart.label.note"),
    comboSkuMssg: t("kf.cart.label.comboSkuMssg"),
    outOfStockToolTip: t("kf.cart.label.outOfStockToolTip"),
    qtyMoreThanToolTip: t("kf.cart.label.qtyMoreThanToolTip"),
    noShippingTooltip: t("kf.cart.label.noShippingTooltip"),
    emptyCartAria: t("kf.cart.label.emptyCartAria"),
    continueCheckoutAria: (count, total) =>
      t("kf.cart.label.continueCheckoutAria", { count: count, total: total }),
    removePromoAria: t("kf.cart.label.removePromoAria"),
    shippingInfoAria: t("kf.cart.label.shippingInfoAria"),
    strikedPrice: t("kf.cart.label.strikedPrice"),
    taxInfoAria: t("kf.cart.label.taxInfoAria"),
    discountPercentage: t("kf.checkout.label.discountPercentage"),
    productDiscounts: t("kf.cart.label.productDiscounts"),
    backOrderMssg: days => t("kf.cart.label.backOrderMssg", { days }),
    off: t("kf.cart.label.off"),
    linearFtNeeded: t("annsacks.pdpTrimCalculator.label.linearFtNeeded"),
    squareFtNeeded: t("annsacks.pdpTrimCalculator.label.squareFtNeeded"),
    overage: t("annsacks.pdpTrimCalculator.label.overage"),
    lf: t("annsacks.pdpTrimCalculator.label.LF"),
    sf: t("annsacks.pdpTrimCalculator.label.SF"),
    totalLF: t("annsacks.pdpTrimCalculator.label.totalLF"),
    totalSF: t("annsacks.pdpTrimCalculator.label.totalSF"),
    pieces: t("annsacks.pdpTrimCalculator.label.pieces"),
    boxes: t("annsacks.pdpTrimCalculator.label.boxes"),
    totalPieces: t("annsacks.pdpTrimCalculator.label.totalPieces"),
    totalBoxes: t("annsacks.pdpTrimCalculator.label.totalBoxes"),
    whatYouWillReceive: t(
      "annsacks.pdpTrimCalculator.label.whatYouWillReceive"
    ),
    totalCoverage: t("annsacks.pdpTrimCalculator.label.totalCoverage"),
    cartLandingCalculatorTitle: t(
      "annsacks.pdpTrimCalculator.label.cartLandingCalculatorTitle"
    ),
    cartLandingCalculatorDescription: t(
      "annsacks.pdpTrimCalculator.label.cartLandingCalculatorDescription"
    ),
    cartLandingCalculatorArea: t("annsacks.pdpTrimCalculator.label.area"),
    cartLandingCalculatorRecalculate: t(
      "annsacks.pdpTrimCalculator.label.recalculate"
    ),
    qtyMoreThanStock: (stock, qty) =>
      t("kf.cart.label.qtyMoreThanStock", { qty, stock }),
    yourSharedCartID: cartNumber =>
      t("kf.share.label.yourSharedCartID", "Cart ID:", { cartNumber }),

    recalculateUpdateCart: t("annsacks.recalculate.label.updateCart"),
    recalculateLinearFt: t("annsacks.recalculate.label.linearFt"),
    recalculateSqureFt: t("annsacks.recalculate.label.squreFt"),
    mailSubject: t("kf.share.label.emailSubject"),
    noItemsToShip: t("kf.cart.label.noItemsToShip"),
    availableToShip: qty => t("kf.cart.label.availableToShip", { qty }),
    removeDiscountErrorMsg: t("kf.cart.label.removeDiscountErrorMsg"),
    qtyMinus: "Quantity minus",
    qtyPlus: "Quantity plus",
    profileFailure: t("kf.account.label.profileFailure"),
    signIn: t("kf.loggedin.button.signIn"),
    needHelpOrder: t("kf.cart.label.needHelpOrder"),
    kohlerOrders: t("kf.cart.label.kohlerOrders"),
    promocode: t("kf.cart.label.promocode"),
    signInItemsPreviously: t("kf.cart.label.signInItemsPreviously"),
    proceedToCheckout: t("kf.cart.label.proceedToCheckout"),
    item: t("kf.list.table.item"),
    itemPrice: t("kf.list.table.itemPrice"),
    itemDiscount: t("kf.cart.label.itemdiscount"),
    calculatedInCheckout: t("kf.cart.label.calculatedInCheckout"),
    tax: t("kf.ordersummary.label.tax"),
    shipping: t("kf.list.table.shipping"),
    saveAddressMyAccount: t("kf.checkout.label.saveAddressMyAccount"),
    inStock: t("kf.cart.label.inStock"),
    checkout: t("kf.cart.label.checkout"),
    totalPrice: t("annsacks.pdpTrimCalculator.label.totalPrice"),
    bucket: t("annsacks.annsacksPdp.label.bucket"),
    perBox: t("annsacks.pdpProductSummary.label.perBox"),
    perEach: t("annsacks.pdpProductSummary.label.perEach"),
    saveOnBundle: number => t("kf.pdp.bundles.saveOnBundle", { number }),
    availableToShipMsg: qty => t("kf.cart.label.availableToShipMsg", { qty }),
    increaseQuantity: t("kf.pdp.label.increaseQuantity"),
    decreaseQuantity: t("kf.pdp.label.decreaseQuantity"),
    minimumReached: t("kf.pdp.label.minimumReached"),
  }
}
